import { useState, useEffect, useCallback } from 'react'

const BUMP_EVENT = 'orderBumpChange'

interface BumpState {
  bump1: boolean
  bump2: boolean
}

function getBumpState(): BumpState {
  try {
    const stored = localStorage.getItem('orderBumps')
    if (stored) return JSON.parse(stored)
  } catch {}
  return { bump1: false, bump2: false }
}

function saveBumpState(state: BumpState) {
  localStorage.setItem('orderBumps', JSON.stringify(state))
  window.dispatchEvent(new CustomEvent(BUMP_EVENT, { detail: state }))
}

export function useOrderBumps() {
  const [bump1Selected, setBump1Raw] = useState(() => getBumpState().bump1)
  const [bump2Selected, setBump2Raw] = useState(() => getBumpState().bump2)

  const setBump1Selected = useCallback(
    (val: boolean | ((prev: boolean) => boolean)) => {
      setBump1Raw((prev) => {
        const next = typeof val === 'function' ? val(prev) : val
        const current = getBumpState()
        saveBumpState({ ...current, bump1: next })
        return next
      })
    },
    [],
  )

  const setBump2Selected = useCallback(
    (val: boolean | ((prev: boolean) => boolean)) => {
      setBump2Raw((prev) => {
        const next = typeof val === 'function' ? val(prev) : val
        const current = getBumpState()
        saveBumpState({ ...current, bump2: next })
        return next
      })
    },
    [],
  )

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<BumpState>).detail
      setBump1Raw(detail.bump1)
      setBump2Raw(detail.bump2)
    }
    window.addEventListener(BUMP_EVENT, handler)
    return () => window.removeEventListener(BUMP_EVENT, handler)
  }, [])

  return { bump1Selected, bump2Selected, setBump1Selected, setBump2Selected }
}

export function getActiveCheckoutUrl(
  baseUrl: string,
  bump1: boolean,
  bump2: boolean,
): string {
  if (bump1 && bump2)
    return 'https://pay.hotmart.com/Q104389187Y?checkoutMode=10'
  if (bump1) return 'https://pay.hotmart.com/W104387446K?checkoutMode=10'
  if (bump2) return 'https://pay.hotmart.com/V104388710B?checkoutMode=10'
  return baseUrl
}

export function getOrderTotal(bump1: boolean, bump2: boolean): number {
  return 19999 + (bump1 ? 19000 : 0) + (bump2 ? 17000 : 0)
}

export function getItemCount(bump1: boolean, bump2: boolean): number {
  return 1 + (bump1 ? 1 : 0) + (bump2 ? 1 : 0)
}
